export const STUDY_GOAL_QUESTION = 'What do you want to get better at?'

export const STUDY_GOAL_OPTIONS = [
  { key: 'speakingInMeetings', i18nKey: 'speakingInMeetings' },
  { key: 'networking', i18nKey: 'networking' },
  { key: 'startingConversations', i18nKey: 'startingConversations' },
  { key: 'smallTalk', i18nKey: 'smallTalk' },
  { key: 'publicSpeaking', i18nKey: 'publicSpeaking' },
  { key: 'persuasionSkills', i18nKey: 'persuasionSkills' },
  { key: 'leadershipAndInfluence', i18nKey: 'leadershipAndInfluence' },
  { key: 'careerSuccess', i18nKey: 'careerSuccess' },
  { key: 'selfConfidence', i18nKey: 'selfConfidence' },
  { key: 'activeListening', i18nKey: 'activeListening' },
  { key: 'conflictResolution', i18nKey: 'conflictResolution' },
  { key: 'presentationSkills', i18nKey: 'presentationSkills' },
] as const
